import React, { memo, Suspense } from "react";
import styles from "./Index.module.less";
import { Skeleton } from "antd";
import HotInquiry from "./HotInquiry"

const NewCarRelease = React.lazy(() => import("./NewCarRelease"));
const SalesRank = React.lazy(() => import("./SalesRank"));
const NetFriendHotSearch = React.lazy(() => import("./NetFriendHotSearch"));
const HotArticle = React.lazy(() => import("./HotArticle"));

interface IProps {
  activityInfo?: string;
}

const List = React.memo((props: IProps) => {
  return (
    <>
      {["modelIndex", "modelEVSearch"].includes(window.PAGE_NAME) && <HotInquiry />}
      {["modelIndex"].includes(window.PAGE_NAME) && (
        <Suspense fallback={<Skeleton style={{ height: 250 }} />}>
          <div id='tcCheckCar' className={styles["tcCheckCar"]}></div>
          <NewCarRelease />
          <SalesRank />
          <NetFriendHotSearch />
          <HotArticle />
        </Suspense>
      )}
    </>
  );
});

export default memo(List);
